var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundIconTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 80,
    viewBox: "0 0 95 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.625 49.125V25.5625L47.3125 2L2 25.5625L47.3125 49.125L70.875 38.25V63.625C70.875 70.875 60 78.125 47.3125 78.125C34.625 78.125 23.75 70.875 23.75 63.625V38.25",
    stroke: "#F8C8CF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIconTwo);
export default __webpack_public_path__ + "static/media/background_icon_two.a67f2ef1fd4bd0fa0220ac4fb87847cd.svg";
export { ForwardRef as ReactComponent };